import React, {Component, Fragment} from "react";
import axios from "axios";
import animateScrollTo from 'animated-scroll-to';

import Question from "./Question";
import SelectedInsect from "./SelectedInsect";
import InsectGrid from "./InsectGrid";
import ShowContact from "./ShowContact";
import LikelyResults from "./LikelyResults";

const NONE = 'NONE';
const IN_PROGRESS = 'IN_PROGRESS';
const COMPLETED = 'COMPLETED';

class ProblemSolver extends Component
{

    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            questions: null,
            insects: null,
            answerTree: [],
            selectedInsectIds: null,
            showContact: false,
            selectedInsect: null,
            likelyInsects: [],
            status: NONE
        }

        this.selectedRef = React.createRef();
        this.contactRef = React.createRef();
        this.lastQuestionRef = React.createRef();

        this.selectAnswer = this.selectAnswer.bind(this);
        this.getInsectById = this.getInsectById.bind(this);
        this.selectInsect = this.selectInsect.bind(this);
        this.showContact = this.showContact.bind(this);
        this.sendContact = this.sendContact.bind(this);
    }

    componentDidMount() {
        this.loadData();
    }

    loadData() {
        axios.get(this.props.endpoint).then((response) => {
            const data = response.data;
            const tree = [
                data.questions[0]
            ];
            this.setState({
                loading: false,
                questions: data.questions,
                insects: data.insects,
                answerTree: tree
            });

        });
    }

    scrollToElement(dom)
    {
        const rect = dom.getBoundingClientRect();
        const y = rect.y + window.scrollY - 100;
        let speed = 100;
        animateScrollTo(y, {
            speed: speed
        });
    }

    selectAnswer(answer)
    {
        const answerTree = [];
        // first remove everything after this question.
        let found = false;
        for (const question of this.state.questions) {
            if (!found) {
                const questionInTree = this.getQuestionFromTreeById(question.id);
                if (question.id === answer.question) {
                    question.selectedAnswer = answer;
                }
                if (questionInTree) {
                    answerTree.push(questionInTree);
                }
            }
            if (question.id === answer.question) {
                found = true;
            }
        }
        if (answer.next_question) {
            answerTree.push(this.getQuestionById(answer.next_question));
        }
        this.setState({
            answerTree: answerTree,
            showContact: false,
            selectedInsectIds: null,
            selectedInsect: null,
        }, () => {
            if (answer.next_question) {
                if (this.lastQuestionRef.current) {
                    this.scrollToElement(this.lastQuestionRef.current);
                }
            }
        });
        // tree is drawn.


        if (!answer.next_question) {

            if (answer.insect_ids.length) {
                this.setState({
                    selectedInsectIds: answer.insect_ids,
                    showContact: false,
                }, () => {
                    if (this.selectedRef.current) {
                        this.scrollToElement(this.selectedRef.current);
                    }
                });
            } else {
                this.setState({
                    showContact: true,
                    selectedInsectIds: null,
                }, () => {
                    if (this.contactRef.current) {
                        this.scrollToElement(this.contactRef.current);
                    }
                })
            }
        }

        const likelyInsects = [];
        for (const question of answerTree) {
            if (question.selectedAnswer && question.selectedAnswer.insect_ids) {
                for (const id of question.selectedAnswer.insect_ids) {
                    const inSelect = likelyInsects.findIndex(insect => {
                        return id === insect.id;
                    })
                    if (inSelect >= 0) {
                        likelyInsects[inSelect]['count'] += 1;
                    } else {
                        const insect = this.getInsectById(id);
                        insect['count'] = 1;
                        likelyInsects.push(insect);
                    }
                }
            }
        }

        likelyInsects.sort((a, b) => {
            if (a.count > b.count) {
                return -1;
            }
            if (a.count < b.count) {
                return 1;
            }
            return 0;
        })

        this.setState({
            likelyInsects: likelyInsects.splice(0, 2)
        })


    }


    getFirstQuestion()
    {
        return this.state.questions[0];
    }

    getQuestionById(id)
    {
        return this.state.questions.find(q => q.id === id);
    }

    getInsectById(id)
    {
        return this.state.insects.find(i => i.id === id);
    }

    getQuestionFromTreeById(id)
    {
        return this.state.answerTree.find(q => q.id === id);
    }

    selectInsect(insect)
    {
        this.setState({
            selectedInsect: insect,
            showContact: false
        }, () => {
            if (this.selectedRef.current) {
                this.scrollToElement(this.selectedRef.current);
            }
        })
    }

    showContact()
    {
        this.setState({
            selectedInsect: null,
            showContact: true
        }, () => {
            if (this.contactRef.current) {
                this.scrollToElement(this.contactRef.current);
            }
        });
    }

    sendContact(name, email, message, file, token)
    {
        this.setState({
            status: IN_PROGRESS
        })
        axios.post(this.props.submissions, {
            data: {
                name: name,
                email: email,
                message: message,
                file: file,
                token: token
            }
        }).then((response) => {
            this.setState({
                status: COMPLETED
            }, () => {
                window.setTimeout(() => {
                    this.setState({
                        status: NONE
                    })
                }, 10 * 1000)
            });
        })
    }

    render()
    {
        if (this.state.loading) {
            return '';
        }
        const questions = [];
        let index = 1;
        for (const question of this.state.answerTree) {
            questions.push(<div
                key={'question_' + question.id}
                ref={index === this.state.answerTree.length ? this.lastQuestionRef : null}>
                <Question
                    question={question}
                    selectAnswer={this.selectAnswer}
                    index={index} />
            </div>);

            index += 1;
        }

        let insectsWidget = null;
        if (this.state.selectedInsectIds && this.state.selectedInsectIds.length) {
            insectsWidget = <InsectGrid
                insects={this.state.selectedInsectIds}
                index={index}
                getInsectById={this.getInsectById}
                selectInsect={this.selectInsect}
                showContact={this.showContact}
            />
            index += 1;
        }



        return <Fragment>
            <div className="problem-solver__inner">
                <div className="problem-solver__body">
                    {questions}
                    {insectsWidget}
                </div>
                <div className="problem-solver__sidebar">
                    <div className="problem-solver__sticky">
                        <LikelyResults results={this.state.likelyInsects} />
                    </div>
                </div>
            </div>
            {!!this.state.selectedInsect && <div ref={this.selectedRef}>
                <SelectedInsect insect={this.state.selectedInsect} index={index} />
            </div>}
            {!!this.state.showContact && <div ref={this.contactRef}>
                <ShowContact
                    index={index}
                    status={this.state.status}
                    uploadEndpoint={this.props.upload}
                    sendContact={this.sendContact}/>
            </div>}
        </Fragment>;



    }


}

export default ProblemSolver;
